import React, { FC } from 'react';
import { debounce } from 'lodash';
import { Controller } from 'react-hook-form';
import { ComboBox, FormControl } from '@fiverr-private/orca';
import { logger } from '@fiverr-private/obs';
import { translate as t } from '@fiverr-private/i18n-react';
import { T_FORM_KEY } from '../../utils';
import { skillsAutocomplete } from '../../../../apis/workExperience';
import { FieldComponentProps } from '../../shared/types';

import { comboBoxStyle } from '../../shared/styles.ve.css';

const mapSkills = (skills) => skills.map((skill) => ({ label: skill.value, value: skill.value }));

const handleTextChange = (text: string, callback: (text: string) => void) => {
    skillsAutocomplete(text?.toLowerCase())
        .then((skills) => callback(mapSkills(skills || [])))
        .catch((error) => logger.error('Error in skillsAutocomplete', error));
};

const debouncedSkillsAutocomplete = debounce(handleTextChange, 500, { leading: true, maxWait: 1000 });

const SkillsField: FC<FieldComponentProps> = ({ control }) => (
    <FormControl label={t(`${T_FORM_KEY}.fields.skills.label`)} isOptional>
        <Controller
            name="skills"
            control={control}
            render={({ field: { onChange, value: skills, name } }) => (
                <ComboBox
                    menuShouldBlockScroll
                    ChevronComponent={() => <></>}
                    id={name}
                    className={comboBoxStyle}
                    placeholder={t(`${T_FORM_KEY}.fields.skills.placeholder`)}
                    isMulti
                    isAsync
                    loadOptions={debouncedSkillsAutocomplete}
                    onChange={(values) => onChange(values.map(({ label }) => label))}
                    value={skills?.map((skill) => ({ label: skill, value: skill }))}
                    hideSelectedOptions={false}
                    noOptionsHide
                />
            )}
        />
    </FormControl>
);

export default SkillsField;
